import Vue from 'vue'
import { VuejsDatatableFactory } from 'vuejs-datatable'
Vue.use(VuejsDatatableFactory)
